import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=6b22415a&scoped=true&"
import script from "./logList.vue?vue&type=script&lang=js&"
export * from "./logList.vue?vue&type=script&lang=js&"
import style0 from "./logList.vue?vue&type=style&index=0&id=6b22415a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22415a",
  null
  
)

export default component.exports